import { useEffect, useState } from "react";
import { Loader2, Send } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

const IDEAS = ["Pickup at: ", "Text me at: ", "Available today until: ", "Please bring exact cash."];

export function MessageDialog({ open, title, description, defaultText = "", skipLabel, onSend, onSkip, onClose }) {
  const [text, setText] = useState(defaultText);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) setText(defaultText);
  }, [open, defaultText]);

  const run = async (fn) => {
    setBusy(true);
    try {
      await fn();
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && !busy && onClose()}>
      <DialogContent className="max-w-lg" data-testid="client-message-dialog">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <div className="flex flex-wrap gap-1.5">
          {IDEAS.map((i, idx) => (
            <button key={i} type="button" onClick={() => setText((t) => (t ? `${t}\n${i}` : i))} data-testid={`client-message-idea-${idx}`}
              className="rounded-full border border-border px-3 py-1 text-xs text-muted-foreground transition-colors hover:border-emerald-500 hover:text-foreground">
              + {i.replace(/: $/, "")}
            </button>
          ))}
        </div>
        <Textarea rows={6} value={text} onChange={(e) => setText(e.target.value)} placeholder="e.g. Pickup at 123 Main St, side door. Text me at (555) 123-4567 when you're 5 min away."
          data-testid="client-message-input" autoFocus />
        <p className="text-xs text-muted-foreground">Emailed to the client and shown on their order in My Orders.</p>
        <div className="flex flex-wrap justify-end gap-2">
          {onSkip && <Button variant="ghost" disabled={busy} onClick={() => run(onSkip)} data-testid="client-message-skip-button">{skipLabel || "Skip"}</Button>}
          <Button disabled={busy || !text.trim()} onClick={() => run(() => onSend(text.trim()))} className="gap-2" data-testid="client-message-send-button">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}Send to client
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
